import { useSelector } from 'react-redux';
import { permissionsSelector } from '$store/main';

export const useAdmin = () => {
  const permissions = useSelector(permissionsSelector)
  const isAdmin = Object.values(permissions).filter(Boolean).length;
  return [
    isAdmin,
    permissions
  ]
}
